import React, { useEffect, useState } from 'react';
import { Hand, X } from 'lucide-react';

const DONE_KEY = 'panHintDone';
const SEEN_KEY = 'panHintGames';
const MAX_GAMES = 2;

const isTouch = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches;

function shouldShow(gameKey) {
  if (!gameKey || !isTouch() || localStorage.getItem(DONE_KEY) === '1') return false;
  let seen = [];
  try { seen = JSON.parse(localStorage.getItem(SEEN_KEY) || '[]'); } catch (_) { seen = []; }
  if (seen.includes(gameKey)) return true;
  if (seen.length >= MAX_GAMES) return false;
  localStorage.setItem(SEEN_KEY, JSON.stringify([...seen, gameKey]));
  return true;
}

export const PanHint = ({ gameKey }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => { setVisible(shouldShow(gameKey)); }, [gameKey]);

  useEffect(() => {
    if (!visible) return undefined;
    const onTouch = (e) => { if (e.touches.length >= 2) finish(); };
    window.addEventListener('touchstart', onTouch, { passive: true });
    return () => window.removeEventListener('touchstart', onTouch);
  }, [visible]);

  function finish() {
    localStorage.setItem(DONE_KEY, '1');
    setVisible(false);
  }

  if (!visible) return null;
  return (
    <div
      className="pan-hint pointer-events-none absolute left-1/2 -translate-x-1/2 top-2 z-20 flex items-center gap-1.5 rounded-full pl-3 pr-1 py-1 text-[11px] font-medium shadow-md bg-[#8B5A3C]/90 text-[#FFF3E4] backdrop-blur-sm animate-in fade-in slide-in-from-top-1 duration-500"
      data-testid="pan-hint"
      role="status"
    >
      <Hand className="w-3.5 h-3.5" />
      <span className="whitespace-nowrap">Two fingers to move the grid</span>
      <button
        onClick={finish}
        className="pointer-events-auto p-0.5 rounded-full hover:bg-white/15 transition-colors"
        aria-label="Dismiss hint"
        data-testid="pan-hint-dismiss-btn"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
